import React from 'react';
import { Box, TextField, Button } from '@mui/material';

const UserInfoForm = ({
  classes,
  userInfo,
  stepStatus,
  onChange,
  onSubmit,
  onVerifyExistingVerifiedId,
  verifiedIdInProgress,
}) => {
  const disabled = stepStatus['user-info'] === 'completed';

  return (
    <form className={classes.form}>
      <TextField
        className={classes.formField}
        label="First Name"
        name="firstName"
        type="text"
        value={userInfo.firstName}
        onChange={onChange}
        variant="outlined"
        fullWidth
        disabled={disabled}
      />
      <TextField
        className={classes.formField}
        label="Last Name"
        name="lastName"
        type="text"
        value={userInfo.lastName}
        onChange={onChange}
        variant="outlined"
        fullWidth
        disabled={disabled}
      />
      <TextField
        className={classes.formField}
        label="Email Address"
        name="email"
        type="email"
        value={userInfo.email}
        onChange={onChange}
        variant="outlined"
        fullWidth
        disabled={disabled}
      />
      <TextField
        className={classes.formField}
        label="Phone Number (with country code)"
        name="phone"
        type="tel"
        value={userInfo.phone}
        onChange={onChange}
        variant="outlined"
        fullWidth
        placeholder="+11234567890"
        helperText="Include country code (e.g., +11234567890)"
        disabled={disabled}
      />
      <TextField
        className={classes.formField}
        label="Date of Birth"
        name="dob"
        type="date"
        value={userInfo.dob}
        onChange={onChange}
        variant="outlined"
        fullWidth
        InputLabelProps={{ shrink: true }}
        disabled={disabled}
      />
      <TextField
        className={classes.formField}
        label="National ID Number"
        name="nationalIdNumber"
        type="text"
        value={userInfo.nationalIdNumber}
        onChange={onChange}
        variant="outlined"
        fullWidth
        disabled={disabled}
      />
      <TextField
        className={classes.formField}
        label="National ID Type"
        name="nationalIdType"
        type="text"
        value={userInfo.nationalIdType}
        onChange={onChange}
        variant="outlined"
        fullWidth
        placeholder="e.g., Passport, Driver's License"
        disabled={disabled}
      />
      <Box className={classes.buttonContainer}>
        <Button
          variant="outlined"
          color="primary"
          onClick={onVerifyExistingVerifiedId}
          disabled={disabled || verifiedIdInProgress}
        >
          Verify Existing Verified ID
        </Button>
        <Button
          variant="contained"
          color="primary"
          onClick={onSubmit}
          disabled={disabled}
        >
          Submit & Continue
        </Button>
      </Box>
    </form>
  );
};

export default UserInfoForm;